/** @returns {HTMLElement} */
export function createFeedbackButton() {
  const container = document.createElement('div');
  container.className = 'feedback-container';

  const btn = document.createElement('a');
  btn.href = '#';
  btn.className = 'feedback-button';
  btn.setAttribute('aria-label', 'Pray');
  btn.setAttribute('tabindex', '0');

  const icon = document.createElement('i');
  icon.className = 'fas fa-message feedback-icon';
  icon.setAttribute('aria-hidden', 'true');

  const tooltip = document.createElement('div');
  tooltip.className = 'feedback-tooltip';
  tooltip.textContent = 'Pray';

  const tooltipArrow = document.createElement('div');
  tooltipArrow.className = 'feedback-tooltip-arrow';
  tooltip.appendChild(tooltipArrow);

  btn.appendChild(icon);
  btn.appendChild(tooltip);
  container.appendChild(btn);

  return container;
}

/** @param {Event} e */
export async function handleFeedbackClick(e) {
  e.preventDefault();
  try {
    const module = await import('../../js/components/FeedbackModal.js');
    const FeedbackModal = module?.default;
    if (!FeedbackModal) return;
    const modal = new FeedbackModal();
    await modal.show();
  } catch (err) {
    console.error('Failed to open feedback modal:', err);
  }
}
